module.exports = __webpack_public_path__ + "47c5dc53b58591df5c67e2d54a081da4.png";


//////////////////
// WEBPACK FOOTER
// ./client/views/AuthView/images/logos.png
// module id = 2181
// module chunks = 0